import { localizedV2Path } from '@marketplace/helpers/forceV2.js'

/**
 * Client-side safety net that keeps retailers with the `marketplace-v2` feature on the
 * new Livewire "/v2" marketplace during in-SPA navigations.
 *
 * Hard navigations / external entry are handled before Nuxt boots by
 * server/middleware/force-v2-redirect.js (cookie-based, no flash). This middleware
 * covers client-side route changes and the case where the feature was toggled on
 * mid-session (the viewer store is always fresh, the cookie may lag until next login).
 *
 * It reads the live feature state from the store and performs a full-page navigation
 * (window.location) because the v2 marketplace is served by Laravel, not Nuxt, so it
 * cannot be reached through the SPA router.
 *
 * @param {object} root0
 * @param {object} root0.store
 * @param {object} root0.route
 */
export default function forceV2Middleware({ store, route }) {
    if (process.server) {
        return
    }

    // Opt-out set by the v2 debug menu ("switch back to v1 for today"); expires at
    // midnight. While present, honour the retailer's choice and stay on v1.
    if (/(?:^|;\s*)skip_marketplace_v2=/.test(document.cookie)) {
        return
    }

    if (!store.getters['feature/forcesV2'] || store.getters['global/isSupplier']) {
        return
    }

    const target = localizedV2Path(route.path)

    if (!target) {
        return
    }

    const queryIndex = route.fullPath.indexOf('?')
    const query = queryIndex >= 0 ? route.fullPath.slice(queryIndex) : ''

    window.location.replace(target + query)
}
